module.exports = __webpack_public_path__ + "img/vip.552addee.svg";